import type { CoturnCredentials } from '@/types/organization/CoturnCredentials';

/**
 * Abstract service for organization-related operations
 *
 * Provides functionality for:
 * - Retrieving TURN server credentials for WebRTC
 */
export abstract class OrganizationService {
  /**
   * Retrieves time-limited coturn credentials for WebRTC TURN server authentication
   * @param organizationId - The organization's unique identifier
   * @returns CoturnCredentials with username, password, ttl, and server URLs
   */
  abstract getCoturnCredentials(organizationId: string): Promise<CoturnCredentials>;
}
